/**
 * Copyright 2023-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Text } from "@nordcloud/gnui";
import { NoData } from "~/components";
import { isEmpty, isNotNil } from "~/tools";
import { useSendTestPlanActionNotification } from "~/views/plans/hooks";
import { usePlan } from "~/views/plans/PlanDetails/PlanProvider";
import { NotificationItem } from "~/views/plans/PlanDetails/Tabs/NotificationItem";
import { mergePlanActionNotifications } from "../helpers";

export function ActionNotification() {
  const { plan, planAction } = usePlan();
  const planActionNotifications = planAction?.notificationGroups ?? [];

  const [sendTestNotification, { loading: isSendTestLoading }] =
    useSendTestPlanActionNotification({
      planId: plan?.id ?? "",
      planActionId: planAction?.id ?? "",
    });

  if (isEmpty(planActionNotifications)) {
    return (
      <NoData
        hasIcon
        message="There are no Resource and Action-based Notifications"
      />
    );
  }

  const mergedPlanActionNotifications = mergePlanActionNotifications(
    planActionNotifications
  );

  return (
    <>
      <Text weight="medium">Resource and Action-based Notifications</Text>
      {mergedPlanActionNotifications?.map((notification, index) => {
        const { id, triggerEvent } = notification;
        const handleSendTest =
          isNotNil(id) && isNotNil(triggerEvent)
            ? () =>
                sendTestNotification({
                  planActionNotificationGroupId: id,
                  triggerEvent,
                })
            : undefined;

        return (
          <NotificationItem
            item={notification}
            index={index}
            key={id ?? index}
            onSendTest={handleSendTest}
            isSendTestLoading={isSendTestLoading}
          />
        );
      })}
    </>
  );
}
